import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type {
  ICompleteDocumentReaderUploadFileResponse,
  IDocumentReaderUploadPart,
} from './types';

/** Finishes one file from the browser's own part list, which the backend checks against S3. */
export async function completeDocumentReaderUploadFile(
  uploadId: string,
  fileId: string,
  parts: readonly IDocumentReaderUploadPart[],
  signal?: AbortSignal
): Promise<
  CommendaAiMutationResult<ICompleteDocumentReaderUploadFileResponse>
> {
  return AgentApiRequestHelper.mutate<ICompleteDocumentReaderUploadFileResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}/files/${encodeURIComponent(fileId)}/complete`,
    { method: 'POST', body: { parts }, ...(signal ? { signal } : {}) },
    'Could not finish this file.'
  );
}
